import { render, staticRenderFns } from "./AboutMessage.vue?vue&type=template&id=18c55138&scoped=true&"
import script from "./AboutMessage.vue?vue&type=script&lang=js&"
export * from "./AboutMessage.vue?vue&type=script&lang=js&"
import style0 from "./AboutMessage.vue?vue&type=style&index=0&id=18c55138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c55138",
  null
  
)

export default component.exports